import md5 from 'md5';
var getAvatarSource = function getAvatarSource(hash, size) {
  return "https://www.gravatar.com/avatar/".concat(hash, "?s=").concat(size, "&r=g&d=blank");
};
var getAvatarSources = function getAvatarSources(email) {
  if (!email) return {};
  var formattedEmail = email.trim().toLowerCase();
  var hash = md5(formattedEmail, {
    encoding: 'binary'
  });
  return {
    src: getAvatarSource(hash, 50),
    srcSet: ["".concat(getAvatarSource(hash, 100), " 2x"), "".concat(getAvatarSource(hash, 150), " 3x")].join()
  };
};
export default getAvatarSources;